
  import { Component, Vue } from 'vue-property-decorator';
  import AppPageHeader from "@/components/AppPageHeader.vue";
  import {IApp} from "@/interfaces/app.interface";
  import ROUTE_NAME = IApp.ROUTE_NAME;
  import {IDialogStoreState} from "@/modules/Popup/interfaces/dialog.interface";
  import IntroDashboard from "@/modules/Dashboard/components/IntroDashboard.vue";

  @Component({
    components: {
      AppPageHeader,
      IntroDashboard,
    },
  })

  export default class DashboardPage extends Vue {
    isLoading: boolean = true;
    routes = ROUTE_NAME;

    get popups(): IDialogStoreState { return this.$store.state.dialog; }

    async created () {
      try {
        await this.$store.dispatch('auth/init');
        await this.$store.dispatch('book/initBooksForPage', this.$route.name);
        await this.$store.dispatch('dashboard/init');

        await this.$store.dispatch('initialized');
        this.isLoading = false;
      }
      catch (error) {
        await this.$store.dispatch('handleError', error);
      }
    }

    destroyed() {
      this.$store.commit('dashboard/clearFilters');
    }
  }
